<script setup lang="ts">
import { ChevronLeftIcon } from "@heroicons/vue/24/outline";
import { twMerge } from "tailwind-merge";
import { ref } from "vue";

import { useUser } from "@/composables/api/useUser";

import PhotoTutorialCarousel from "@/components/sections/submit-receipt/PhotoTutorialCarousel.vue";
import AskInitialPhoto from "@/components/sections/take-receipt-photo/AskInitialPhoto.vue";
import PhotoCaptureUploader from "@/components/sections/take-receipt-photo/PhotoCaptureUploader.vue";
import Dialog from "@/components/ui/Dialog.vue";

const { data: user } = useUser();

const files = ref<File[]>([]);
const blobUrls = ref<string[]>([]);
const isDialogOpen = ref<boolean>(true);

function closeDialog() {
  isDialogOpen.value = false;
}
</script>

<template>
  <main
    class="relative mx-auto flex h-svh max-w-xl flex-col overflow-hidden"
    role="main"
    aria-label="Capture de photos de tickets"
  >
    <button
      type="button"
      :class="
        twMerge(
          'border-galbani text-galbani absolute top-4 left-4 z-[1] flex size-12 cursor-pointer items-center justify-center rounded-full border bg-white',
          blobUrls.length > 0 && 'border-transparent shadow-lg',
          user?.current_mechanic === 'lactel' && 'text-lactel-blue border-lactel-blue',
        )
      "
      aria-label="Retour à la page précédente"
      @click="$router.push({ path: '/tableau-de-bord/accueil/cadeaux' })"
    >
      <ChevronLeftIcon class="size-8" aria-hidden="true" />
    </button>

    <Transition name="fade-slide" mode="out-in">
      <AskInitialPhoto
        v-if="blobUrls.length === 0"
        v-model:blobs="blobUrls"
        v-model:files="files"
      />

      <PhotoCaptureUploader v-else v-model:blobs="blobUrls" v-model:files="files" />
    </Transition>
  </main>

  <Dialog v-model:open="isDialogOpen">
    <template #content>
      <PhotoTutorialCarousel @close="closeDialog" />
    </template>
  </Dialog>
</template>

<style lang="css" scoped>
/* Base transition duration and timing */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

/* Enter: start state */
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

/* Leave: end state */
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* Enter: end state + Leave: start state */
.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
